import type { ComponentType } from 'react';
import type { PublicSectionType } from '@/lib/types/public-pages';
import type { SectionRendererProps } from './section-renderer.types';
import { HeroRenderer } from './renderers/HeroRenderer';
import { StatsBarRenderer } from './renderers/StatsBarRenderer';
import { CardGridRenderer } from './renderers/CardGridRenderer';
import { CtaBannerRenderer } from './renderers/CtaBannerRenderer';
import { QuoteCarouselRenderer } from './renderers/QuoteCarouselRenderer';
import { MissionSplitRenderer } from './renderers/MissionSplitRenderer';
import { EventsTeaserRenderer } from './renderers/EventsTeaserRenderer';
import { ChecklistSplitRenderer } from './renderers/ChecklistSplitRenderer';
import { ApplicationFormRenderer } from './renderers/ApplicationFormRenderer';
import { ComparisonSplitRenderer } from './renderers/ComparisonSplitRenderer';
import { CategoryBandRenderer } from './renderers/CategoryBandRenderer';

export type { SectionRendererProps };

/**
 * Public section-renderer registry (MYN-197, MYN-198). Mirrors the idiom
 * Backend's `SECTION_TYPES` (§18/§19) and this repo's own admin
 * `SECTION_FIELD_REGISTRY` (§16) already use - adding a section type is one
 * entry here, never a switch/if-chain on `type` (docs/specs/02-design.md
 * §17, Option A).
 */
export const SECTION_RENDERERS: Record<PublicSectionType, ComponentType<SectionRendererProps>> = {
  hero: HeroRenderer,
  'stats-bar': StatsBarRenderer,
  'card-grid': CardGridRenderer,
  'cta-banner': CtaBannerRenderer,
  'quote-carousel': QuoteCarouselRenderer,
  'mission-split': MissionSplitRenderer,
  'events-teaser': EventsTeaserRenderer,
  'checklist-split': ChecklistSplitRenderer,
  'application-form': ApplicationFormRenderer,
  'comparison-split': ComparisonSplitRenderer,
  'category-band': CategoryBandRenderer,
};

export function isRenderableSectionType(value: string): value is PublicSectionType {
  return Object.prototype.hasOwnProperty.call(SECTION_RENDERERS, value);
}
